module.exports = __webpack_public_path__ + "static/media/offer-5.202f023e.png";